<section class="flex h-auto w-full p-5 border-b border-sb-border-primary bg-sb-surface-primary transition-all duration-[0.4ms] ease-in-out"
  [ngClass]="getDrawerStatus() ? 'p-5' : 'py-5 px-2'">
    <main class="flex w-full flex-col gap-4">
        <div class="mb-0 flex w-full items-center"
        [ngClass]="getDrawerStatus() ? 'justify-between' : 'justify-center'"  >
            @if (getDrawerStatus()) {
              <div class="flex items-center">
                <language-selector
                  [languageOptions]="supportedLanguages"
                  (languageSelect)="onLanguageSelect($event)">
                </language-selector>
              </div>
            }
            <div class="flex items-center justify-center">
                <button
                  type="button"
                  data-intercom-target="sidebar-drawer-toggle"
                  [pTooltip]="getDrawerToolTip() | translate"
                  tooltipPosition="right"
                  (click)="toggleDrawerStatus()"
                  class="flex h-7 w-7 p-0.5 items-center justify-center rounded-[4px] border border-sb-border-secondary bg-sb-surface-primary shadow-xs">
                    @if (isSmallScreen && getDrawerStatus()) {
                      <sb-icon name="close" size="xs" />
                    } @else {
                      <sb-icon [name]="drawerChevronIcon" size="xs" />
                    }
                </button>
            </div>
        </div>
        @if (checkIfAccountHasClients()) {
          @if (getDrawerStatus()) {
            <button
              type="button"
              data-intercom-target="client-selector"
              [pTooltip]="'STORES' | translate"
              tooltipPosition="bottom"
              (click)="showStores($event)"
              [disabled]="activeProgress"
              class="flex h-12 w-full cursor-pointer items-center justify-between rounded-lg border-0 bg-primary p-2 shadow-lg hover:bg-sb-surface-brand-primary-hover active:bg-sb-surface-brand-primary-pressed disabled:cursor-not-allowed disabled:opacity-60"
              [ngClass]="{ 'bg-sb-surface-brand-primary-pressed': isSmallScreen && isStoreOpen }">
              <span class="flex min-w-0 items-center gap-2">
                <span class="inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded bg-sb-surface-primary p-1">
                  @if (currentClient?.icon) {
                    <img
                      [src]="currentClient.icon"
                      [alt]="currentClient?.name || 'Client icon'"
                      class="size-full object-cover" />
                  } @else {
                    <sb-icon name="store" class="text-primary" />
                  }
                </span>
                <span class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold leading-[18px] text-sb-surface-primary">{{ currentClient?.name || 'Shopbox' }}</span>
              </span>
              @if (isSmallScreen) {
                <sb-icon
                  name="chevron-down"
                  size="sm"
                  class="text-sb-icon-success-inverted opacity-50-pct transition-transform duration-300 ease-in-out"
                  [class.rotate-180]="isStoreOpen" />
              } @else {
                <sb-icon
                  name="chevron-right"
                  size="sm"
                  class="text-sb-icon-success-inverted opacity-50-pct" />
              }
            </button>
          } @else {
            <button
              type="button"
              data-intercom-target="client-selector"
              [pTooltip]="'STORES' | translate"
              tooltipPosition="bottom"
              (click)="showStores($event)"
              [disabled]="activeProgress"
              class="mx-auto flex h-12 w-12 cursor-pointer items-center justify-center rounded-lg border-0 bg-primary p-2 shadow-lg hover:bg-sb-surface-brand-primary-hover active:bg-sb-surface-brand-primary-pressed disabled:cursor-not-allowed disabled:opacity-60">
              <span class="inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded bg-sb-surface-primary p-1">
                @if (currentClient?.icon) {
                  <img
                    [src]="currentClient.icon"
                    [alt]="currentClient?.name || 'Client icon'"
                    class="size-full object-cover" />
                } @else {
                  <sb-icon name="store" class="text-primary" />
                }
              </span>
            </button>
          }
        }
    </main>
</section>
